import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getWordListApiCall = createAsyncThunk("wordList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: wordList } = await API.getWordListApi(submitData);
        
        //console.log("*********************************************",wordList);
        dispatch(setLoader(false))
        return wordList;
    } catch (error) {
        throw error;
    }
});

export const editWordDataApiCall = createAsyncThunk("editClientData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editWordData, code, message } = await API.updateWordApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editWordData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    wordList: {
        data: [],
        error: null,
    },
    editWordData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const WordSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getWordListApiCall.fulfilled, (state, action) => {
                state.wordList.data = action.payload;
            })
            .addCase(getWordListApiCall.rejected, (state, action) => {
                state.wordList.error = action.error.message;
            })
            .addCase(editWordDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editWordData.data = data;
                state.editWordData.message = message;
                state.editWordData.code = code;
            })
            .addCase(editWordDataApiCall.rejected, (state, action) => {
                state.editWordData.error = action.error.message;
            });
    },
});

export default WordSlice.reducer;